var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"mainForm",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('CaseACocherLive',{attrs:{"code":"decla1","live":_vm.liveSasStage(6509)},model:{value:(_vm.sas.consentement),callback:function ($$v) {_vm.$set(_vm.sas, "consentement", $$v)},expression:"sas.consentement"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }